import { useEffect, useLayoutEffect, useRef } from 'react';

const MARGIN = 8;

const useAnchoredPopup = (anchorRect, onClose) => {
  const popupRef = useRef(null);

  useLayoutEffect(() => {
    const popup = popupRef.current;
    if (!popup || !anchorRect) return;

    const popupH = popup.offsetHeight;
    const popupW = popup.offsetWidth;
    const spaceBelow = window.innerHeight - anchorRect.bottom;

    const top = spaceBelow >= popupH + MARGIN ? anchorRect.bottom + MARGIN : anchorRect.top - popupH - MARGIN;
    const left = Math.min(Math.max(anchorRect.left, MARGIN), window.innerWidth - popupW - MARGIN);

    popup.style.top = `${top}px`;
    popup.style.left = `${left}px`;
    popup.style.visibility = 'visible';
  }, [anchorRect]);

  useEffect(() => {
    const handleOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleOutside);
    document.addEventListener('touchstart', handleOutside, { passive: true });

    return () => {
      document.removeEventListener('mousedown', handleOutside);
      document.removeEventListener('touchstart', handleOutside);
    };
  }, [onClose]);

  return popupRef;
};

export default useAnchoredPopup;
